// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-down.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'arrow-down',
  version: 'outline',
  paths: [
    {
      d: 'M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3',
    },
  ],
}
